import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { useNavigate } from 'react-router';
import { Helmet } from 'react-helmet-async';
import { CTA, CustomSelect, Logo, Text } from '../../../ui/atoms';
import InputLegend from '../../../ui/atoms/InputLegend';
import theme from '../../../ui/theme';
import { withMediaQueries } from '../../hoc/withMediaQueries';
import {
  REGION_PROVINCE_LIST_GET,
  REGION_PROVINCE_SET,
} from '../../redux/actions/user';
import {
  AuthContainer,
  FormContainer,
  InputWrapper,
  LogoContainer,
} from '../Auth/styles';
import { Container } from '../../../ui/gridSystem';
import routes from '../../../routes';
import { ButtonsContainer } from './style';

const AuthSet = ({
  mediaIsPhone,
  regionProvinceGet,
  regionProvinceSet,
  regionProvinceList,
  appConfig,
}) => {
  const navigate = useNavigate();
  const [currentProvinces, setCurrentProvinces] = useState([]);
  const [selectedValues, setSelectedValues] = useState({});

  useEffect(() => {
    regionProvinceGet();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const provincesList = (region_id) => {
    return (
      (regionProvinceList || [])
        .find((item) => item.id === region_id)
        ?.provinces?.map((opt) => ({
          label: opt.name,
          value: opt.id,
        })) || []
    );
  };

  return (
    <>
      <Helmet>
        <title>SISFOR+ - Imposta dati mancanti</title>
      </Helmet>
      <AuthContainer>
        <FormContainer>
          <LogoContainer>
            <Logo
              size={Logo.SIZE.XL}
              src={appConfig?.login_logo?.src}
              alt={appConfig?.login_logo?.alt}
              onClick={() => navigate(routes.auth.path)}
            />
          </LogoContainer>
          <Container className="pt-0">
            <Text type="h1" mb={8} className="title">
              Inserimento dati obbligatori
            </Text>
            <Text type="b3" mb={24}>
              Per fruire dei contenuti presenti sulla piattaforma Sisfor+ è
              necessario, solo per il primo accesso, inserire i dati relativi
              alla propria regione e provincia dell’ufficio assegnato.
            </Text>
            <InputWrapper>
              <InputLegend
                label="Inserisci la tua regione"
                required
                htmlFor="select-region"
              />
              <CustomSelect
                id="select-region"
                isSearchable
                placeholder="Regione"
                options={(regionProvinceList || []).map((opt) => ({
                  label: opt.name,
                  value: opt.id,
                }))}
                onChange={(v) => {
                  setSelectedValues({ region_id: v?.value });
                  setCurrentProvinces(provincesList(v?.value));
                }}
              />
            </InputWrapper>
            <InputWrapper>
              <InputLegend
                label="Inserisci la tua provincia"
                required
                htmlFor="select-province"
              />
              <CustomSelect
                id="select-province"
                isSearchable
                placeholder="Provincia"
                options={currentProvinces || []}
                onChange={(v) =>
                  setSelectedValues({
                    ...selectedValues,
                    province_id: v?.value,
                  })
                }
                selected={
                  (currentProvinces || []).find(
                    (p) => p.value === selectedValues?.province_id
                  ) || null
                }
              />
            </InputWrapper>
            <Text
              type="b3"
              mt={mediaIsPhone ? 24 : 32}
              mb={mediaIsPhone ? 48 : 68}
              color={theme().colors.fail}
            >
              * campo obbligatorio
            </Text>
            <ButtonsContainer>
              <CTA
                type="secondary"
                btnText="annulla"
                fullsize={mediaIsPhone}
                onClick={() => navigate(routes.auth.path)}
              />
              <CTA
                type="primary"
                btnText="conferma"
                fullsize={mediaIsPhone}
                onClick={() => regionProvinceSet(selectedValues, navigate)}
                disabled={
                  !selectedValues?.region_id || !selectedValues?.province_id
                }
              />
            </ButtonsContainer>
          </Container>
        </FormContainer>
      </AuthContainer>
    </>
  );
};

AuthSet.propTypes = {
  //HOC: withMediaQueries
  mediaIsPhone: PropTypes.bool,
  // state
  regionProvinceList: PropTypes.array,
  appConfig: PropTypes.object,
  // dispatch
  regionProvinceGet: PropTypes.func.isRequired,
  regionProvinceSet: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => {
      const { appConfig } = state.app;
      const { regionProvinceList } = state.user;
      return {
        regionProvinceList,
        appConfig,
      };
    },
    (dispatch) => ({
      regionProvinceGet: () =>
        dispatch({ type: REGION_PROVINCE_LIST_GET._REQUEST }),
      regionProvinceSet: (selectedValues, navigate) =>
        dispatch({
          type: REGION_PROVINCE_SET._REQUEST,
          payload: selectedValues,
          navigate,
        }),
    })
  ),
  withMediaQueries
)(AuthSet);
